import { Dropdown } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { checkDpSuccess, getCompanyType, getFormErrorMessage, splitFileExtension } from '../../utility/service/tool-service';
import { Button } from 'primereact/button';
import { AlertService } from '../../utility/service/alert-service';
import { useEffect, useState } from 'react';
import { FormInputFile } from '../../components/FormInputFile';
import ImagePDFComponent from '../../components/ImagePDFComponent';
import { getCompanyPlaceList } from '../../utility/service/carbon-service';

const AddReg = ({
  control,
  errors,
  fileInputRef,
  register,
  setValue,
  planYearList,
  getValues,
  watch,
  trigger,
  setValidForm,
  addDialog
  
}) => {
    const { t } = useTranslation();
    const [fileInfo,setFileInfo] = useState({})
    const [previewUrl,setPreviewUrl] = useState(null);
    const [companyPlaceList,setCompanyPlaceList] = useState([]);

      //組織邊界廠商清單
  const axios_getCompanyPlaceList = ()=>{
    getCompanyPlaceList()
      .then((res)=>{
        if(checkDpSuccess(res)){
          let data = res.data.RespBody.companyPlaceList
          setCompanyPlaceList(data);
          if(getCompanyType()==='A'){
            setValue("add_companySeq",data[0].companySeq);
          }
        }

      })
  }

  useEffect(()=>{
    axios_getCompanyPlaceList();
  },[])


  const handleFileChange = (e)=>{ //每次開啟選擇檔案觸發onChange事件
    // console.log(e.target.files);
    if(e.target.files[0]){ 
        if(e.target.files[0].size >=2000000 ){ //大於2MB 
            AlertService.ok('Error', "Size over 5MB");
            setPreviewUrl(null);
            setValue("add_file","");
            setValue("add_fileExtension","");//副檔名
            trigger("add_file")
            setFileInfo({});
            fileInputRef.current.value = null;
        }else{
            setPreviewUrl(URL.createObjectURL(e.target.files[0]));
            setValue("add_file",e.target.files[0]);
            let fileExtension = splitFileExtension(e.target.files[0]?.name);
            setValue("add_fileExtension",fileExtension);//副檔名
            setFileInfo(e.target.files[0]);
            trigger("add_file")
        }
       
    }
}

const handleDeleteImg = ()=>{ //刪除圖片
    fileInputRef.current.value = null;
    setPreviewUrl(null);
    setValue("add_file","");
    setValue("add_fileExtension","");//副檔名
    trigger("add_file")
}

  return (
    <div className='grid'>
       {/* 廠商名稱 */}
       <div className="col-12">
        <div>
          {/* 必填class required */}
          <label
            htmlFor="add_companySeq"
            className="form-label required">
              {t('organName')}
          </label>
        </div>
        <Controller
          name="add_companySeq"
          control={control}
          rules={setValidForm("companySeq")}
          render={({ field, fieldState }) => (
            <Dropdown
              filter
              optionLabel="companyName"
              optionValue="companySeq"
              value={field.value}
              virtualScrollerOptions={{ itemSize: 40 }}
              defaultValue={""}
              placeholder={t("plz_chs")}
              name="add_companySeq"
              control={control}
              options={companyPlaceList}
              className={`w-full`+classNames({ "p-invalid": fieldState.error })}
              onChange={(event) => {
                field.onChange(event.value);
              }}
            />
          )}
        />
        {getFormErrorMessage(errors,"add_companySeq")}
      </div>

       {/* 場所名稱 */}
       <div className="col-12">
        <div>
          <label
            htmlFor="placeName"
            className="form-label required">
              {t('place_name')}
          </label>
        </div>
        <Controller
          name="add_placeSeq"
          control={control}
          rules={setValidForm("placeSeq")}
          render={({ field, fieldState }) => (
            <Dropdown
              filter
              optionLabel="placeName"
              optionValue="placeSeq"
              value={field.value}
              virtualScrollerOptions={{ itemSize: 40 }}
              defaultValue={""}
              placeholder={t("plz_chs")}
              name="add_placeSeq"
              control={control}
              options={companyPlaceList?.filter((item)=>item.companySeq===watch("add_companySeq"))[0]?.placeList}
              className={`w-full`+classNames({ "p-invalid": fieldState.error })}
              onChange={(event) => {
                field.onChange(event.value);
              }}
            />
          )}
        />
        {getFormErrorMessage(errors,"add_placeSeq")}
      </div>

    {/* 盤查年度(民國) */}
      <div className="col-12">
      <div>
          {/* 必填要給什麼class? */}
          <label
            htmlFor="add_year"
            className="form-label required">
              {t('queryYear_roc')}
          </label>
        </div>
        <Controller
          name="add_year"
          control={control}
          rules={setValidForm("year")}
          render={({ field, fieldState }) => (
            <Dropdown
              filter
              optionLabel="subitemName"
              optionValue="subitemNo"
              value={field.value}
              virtualScrollerOptions={{ itemSize: 40 }}
              defaultValue={""}
              placeholder={t("plz_chs")}
              name="add_year"
              control={control}
              options={planYearList}
              className={`w-full`+classNames({ "p-invalid": fieldState.error })}
              onChange={(event) => {
                field.onChange(event.value);
              }}
            />
          )}
        />
        {getFormErrorMessage(errors,"add_year")}
      </div>

    {/* 盤查登錄表單上傳  */}
    <div className="col-12">
          <FormInputFile
          register={register}
          labelText={t("form_upload")}
          labelClass="required"
          errors={errors}
          id="add_file"
          name="add_file"
          acceptFileType=".xlsx,.xls"
          disabled={false}
          fileChange={handleFileChange}
          fileInputRef={fileInputRef}
          limitSize='2MB'
          rules={{required:{value:addDialog?true:false,message: t('validation.required')}}}
      />
      
      <ImagePDFComponent
          file={fileInfo}
          disabled={false}
          deleteImg={handleDeleteImg}
          previewUrl={previewUrl}
          isLinkClick= {false}
      />
      
  
    </div>

    {/* <Button
            variant="contained"
            component="label"
            sx={{ marginRight: "10px" }}
            onClick={()=>{openFileBrowser("file")}}
          >
            {t("button.chooseFile")}
            <input
              type="file"
              accept=".xlsx,.xls"
              hidden
              onChange={(event)=>{handleFileChange(event?.target?.files)}}
              name="file"
              id="file"
            />
          </Button>
          <div>{fileName}</div> */}
    </div>
  )
}

export default AddReg;